import Hmao from './hmao';
import Yanao from './yanao';

/**
 * Используем пакет i18n
 */
export default {
  hmao: Hmao,
  yanao: Yanao,
};
